module.exports = __webpack_public_path__ + "static/media/89.a8a7a0a4.png";